import { render, staticRenderFns } from "./InventoryOutboundLogs.vue?vue&type=template&id=6b60c83e&scoped=true"
import script from "./InventoryOutboundLogs.vue?vue&type=script&lang=js"
export * from "./InventoryOutboundLogs.vue?vue&type=script&lang=js"
import style0 from "./InventoryOutboundLogs.vue?vue&type=style&index=0&id=6b60c83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b60c83e",
  null
  
)

export default component.exports